import {COLORS, mediaDesktopAndUp, Z_INDEXES} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {PropsWithChildren} from 'react';
import {
  FLYOUT_CONTENT_MAX_HEIGHT_DESKTOP,
  FLYOUT_CONTENT_PADDING,
} from '../../constants';
import {RowSectionStyled} from '../../RowSectionStyled';

interface NavigationFlyoutContentWrapperProps extends PropsWithChildren {
  isOpen: boolean;
  dataTestId?: string;
}

export const NavigationFlyoutContentWrapper: React.FC<
  NavigationFlyoutContentWrapperProps
> = ({dataTestId = 'topCategoryNavigationFlyoutContent', isOpen, children}) => {
  return (
    <div data-testid={dataTestId}>
      <FlyoutContentWrapper
        data-open={isOpen}
        data-testid={`${dataTestId}_wrapper`}
      >
        <FlyoutContent>{children}</FlyoutContent>
      </FlyoutContentWrapper>
    </div>
  );
};

const FlyoutContent = styled(RowSectionStyled)`
  display: none;
  padding-top: ${FLYOUT_CONTENT_PADDING.top}px;
  padding-bottom: ${FLYOUT_CONTENT_PADDING.bottom}px;
  height: 100%;
  overflow: hidden;
  margin: auto;
`;

const FlyoutContentWrapper = styled.div`
  background: ${COLORS.White};
  display: block;
  position: absolute;

  z-index: ${Z_INDEXES.DESKTOP_NAVIGATION_FLYOUT};

  width: 100% !important;

  &[data-open='true'] {
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);

    @media ${mediaDesktopAndUp} {
      min-height: ${FLYOUT_CONTENT_MAX_HEIGHT_DESKTOP}px;
    }

    &::before {
      display: block;
    }

    ${FlyoutContent} {
      display: block;
    }
  }
`;
